import dayjs from 'dayjs';
import 'dayjs/locale/fr';

dayjs.locale('fr');

export default dayjs;

/** Date et heure à la française : 02/10/2026 18h10 */
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH[h]mm';
